import { STORAGE_KEYS, ContractTemplate, TemplateCategory, ContractRecord } from '@/types';
import JSZip from 'jszip';

// 系统预制模板配置（影城专用模板，首次自动导入 localStorage）
const SYSTEM_TEMPLATE_CONFIGS = [
  { id: 'sys-001', name: '1、减租回复函', category: '法务函' as TemplateCategory, fileName: '1、减租回复函（模板）.docx', systemPath: '/templates/1、减租回复函（模板）.docx' },
  { id: 'sys-002', name: '2、减租申请函', category: '法务函' as TemplateCategory, fileName: '2、减租申请函（模板）.docx', systemPath: '/templates/2、减租申请函（模板）.docx' },
  { id: 'sys-003', name: '3、法务函--交付房产通知', category: '法务函' as TemplateCategory, fileName: '3、法务函--交付房产通知（模板）.docx', systemPath: '/templates/3、法务函--交付房产通知（模板）.docx' },
  { id: 'sys-004', name: '4、法务函--提供招商率证明文件', category: '法务函' as TemplateCategory, fileName: '4、法务函--提供招商率证明文件（模板）.docx', systemPath: '/templates/4、法务函--提供招商率证明文件（模板）.docx' },
  { id: 'sys-005', name: '5、法务函-解约通知（未交付房产）', category: '法务函' as TemplateCategory, fileName: '5、法务函-解约通知（未交付房产）（模板）.docx', systemPath: '/templates/5、法务函-解约通知（未交付房产）（模板）.docx' },
  { id: 'sys-006', name: '6、法务函-解约通知（招商率不足）', category: '法务函' as TemplateCategory, fileName: '6、法务函-解约通知（招商率不足）（模板）.docx', systemPath: '/templates/6、法务函-解约通知（招商率不足）（模板）.docx' },
  { id: 'sys-007', name: '保洁服务合同', category: '工程服务' as TemplateCategory, fileName: '保洁服务合同模板.docx', systemPath: '/templates/保洁服务合同模板.docx' },
  { id: 'sys-008', name: '合同主体变更三方协议', category: '补充协议' as TemplateCategory, fileName: '合同主体变更三方协议模板.docx', systemPath: '/templates/合同主体变更三方协议模板.docx' },
  { id: 'sys-009', name: '合同终止协议（商户撤场）', category: '终止协议' as TemplateCategory, fileName: '合同终止协议（商户撤场）模板.docx', systemPath: '/templates/合同终止协议（商户撤场）模板.docx' },
  { id: 'sys-010', name: '合同终止协议（未实际履行）', category: '终止协议' as TemplateCategory, fileName: '合同终止协议（未实际履行）模板.docx', systemPath: '/templates/合同终止协议（未实际履行）模板.docx' },
  { id: 'sys-011', name: '商业房屋转租合同', category: '租赁合同' as TemplateCategory, fileName: '商业房屋转租合同模板.docx', systemPath: '/templates/商业房屋转租合同模板.docx' },
  { id: 'sys-012', name: '场地合作协议', category: '合作协议' as TemplateCategory, fileName: '场地合作协议模板.docx', systemPath: '/templates/场地合作协议模板.docx' },
  { id: 'sys-013', name: '室内装修设计合同', category: '工程服务' as TemplateCategory, fileName: '室内装修设计合同模板.docx', systemPath: '/templates/室内装修设计合同模板.docx' },
  { id: 'sys-014', name: '广告物料制作合同', category: '工程服务' as TemplateCategory, fileName: '广告物料制作合同模板.docx', systemPath: '/templates/广告物料制作合同模板.docx' },
  { id: 'sys-015', name: '建设工程监理合同', category: '工程服务' as TemplateCategory, fileName: '建设工程监理合同模板.docx', systemPath: '/templates/建设工程监理合同模板.docx' },
  { id: 'sys-016', name: '影城包场合作协议', category: '合作协议' as TemplateCategory, fileName: '影城包场合作协议模板.docx', systemPath: '/templates/影城包场合作协议模板.docx' },
  { id: 'sys-017', name: '影城合作商户协议', category: '合作协议' as TemplateCategory, fileName: '影城合作商户协议模板.docx', systemPath: '/templates/影城合作商户协议模板.docx' },
  { id: 'sys-018', name: '影城员工宿舍两方租赁协议', category: '租赁合同' as TemplateCategory, fileName: '影城员工宿舍两方租赁协议模板.docx', systemPath: '/templates/影城员工宿舍两方租赁协议模板.docx' },
  { id: 'sys-019', name: '影城广告合作协议', category: '合作协议' as TemplateCategory, fileName: '影城广告合作协议模板.docx', systemPath: '/templates/影城广告合作协议模板.docx' },
  { id: 'sys-020', name: '影城联盟商户合作协议', category: '合作协议' as TemplateCategory, fileName: '影城联盟商户合作协议模板.docx', systemPath: '/templates/影城联盟商户合作协议模板.docx' },
  { id: 'sys-021', name: '影城防火墙采购框架合同', category: '框架合同' as TemplateCategory, fileName: '影城防火墙采购框架合同模板.docx', systemPath: '/templates/影城防火墙采购框架合同模板.docx' },
  { id: 'sys-022', name: '影城食材供货合同（订单方式）', category: '采购合同' as TemplateCategory, fileName: '影城食材供货合同（订单方式）模板.docx', systemPath: '/templates/影城食材供货合同（订单方式）模板.docx' },
  { id: 'sys-023', name: '服务合同终止协议（保安、保洁）', category: '终止协议' as TemplateCategory, fileName: '服务合同终止协议（保安、保洁）模板.docx', systemPath: '/templates/服务合同终止协议（保安、保洁）模板.docx' },
  { id: 'sys-024', name: '消杀合同', category: '工程服务' as TemplateCategory, fileName: '消杀合同模板.docx', systemPath: '/templates/消杀合同模板.docx' },
  { id: 'sys-025', name: '消防工程合同', category: '工程服务' as TemplateCategory, fileName: '消防工程合同模板.docx', systemPath: '/templates/消防工程合同模板.docx' },
  { id: 'sys-026', name: '租赁合同补充协议书（自动承继主体加退租面积）', category: '补充协议' as TemplateCategory, fileName: '租赁合同补充协议书（自动承继主体加退租面积）.docx', systemPath: '/templates/租赁合同补充协议书（自动承继主体加退租面积）.docx' },
  { id: 'sys-027', name: '耀莱影城正式租赁合同', category: '租赁合同' as TemplateCategory, fileName: '耀莱影城正式租赁合同模板.docx', systemPath: '/templates/耀莱影城正式租赁合同模板.docx' },
  { id: 'sys-028', name: '耀莱成龙影城员工宿舍房屋租赁协议', category: '租赁合同' as TemplateCategory, fileName: '耀莱成龙影城员工宿舍房屋租赁协议模板.docx', systemPath: '/templates/耀莱成龙影城员工宿舍房屋租赁协议模板.docx' },
  { id: 'sys-029', name: '装修合同', category: '工程服务' as TemplateCategory, fileName: '装修合同模板.docx', systemPath: '/templates/装修合同模板.docx' },
  { id: 'sys-030', name: '采购合同', category: '采购合同' as TemplateCategory, fileName: '采购合同模板.docx', systemPath: '/templates/采购合同模板.docx' },
];

// 每次页面加载时重新加载系统模板变量（修复 Word XML 拆分导致的提取失败）
// 保留用户自定义模板，系统模板保留用户可能修改过的名称/分类，只更新变量
export async function initializeSystemTemplates(): Promise<void> {
  const existing = loadFromLocalStorage<ContractTemplate[]>(STORAGE_KEYS.TEMPLATES) || [];
  const customTemplates = existing.filter(t => !t.isSystem);
  const systemTemplates: ContractTemplate[] = [];

  for (const cfg of SYSTEM_TEMPLATE_CONFIGS) {
    const existingSystem = existing.find(t => t.id === cfg.id);

    // 重新 fetch 系统模板文件，提取变量
    let variables: string[] = [];
    try {
      const resp = await fetch(cfg.systemPath);
      if (resp.ok) {
        const arrayBuffer = await resp.arrayBuffer();
        const zip = await JSZip.loadAsync(arrayBuffer);
        const vars = new Set<string>();

        const filesToScan = ['word/document.xml'];
        Object.keys(zip.files).forEach(name => {
          if ((name.startsWith('word/header') || name.startsWith('word/footer')) && name.endsWith('.xml')) {
            filesToScan.push(name);
          }
        });

        for (const filePath of filesToScan) {
          const file = zip.file(filePath);
          if (file) {
            const xmlContent = await file.async('text');
            // 修复：拼接整个 XML 中所有 <w:t> 文本（解决 Word 把 {{变量}} 拆到多个 <w:r> 的问题）
            let fullText = '';
            const textTagsRegex = /<w:t[^>]*>([\s\S]*?)<\/w:t>/g;
            let textMatch;
            while ((textMatch = textTagsRegex.exec(xmlContent)) !== null) {
              fullText += textMatch[1];
            }
            const varRegex = /\{\{([^}]+)\}\}/g;
            let varMatch;
            while ((varMatch = varRegex.exec(fullText)) !== null) {
              vars.add(varMatch[1]);
            }
          }
        }
        variables = Array.from(vars);
      }
    } catch (e) {
      console.warn(`模板 ${cfg.fileName} 变量提取失败:`, e);
    }

    if (existingSystem) {
      // 保留用户可能修改过的名称和分类，只更新变量
      systemTemplates.push({
        ...existingSystem,
        variables,
        systemPath: cfg.systemPath,
      });
    } else {
      systemTemplates.push({
        id: cfg.id,
        name: cfg.name,
        category: cfg.category,
        fileName: cfg.fileName,
        uploadTime: '系统预制',
        variables,
        isSystem: true,
        systemPath: cfg.systemPath,
      });
    }
  }

  saveToLocalStorage(STORAGE_KEYS.TEMPLATES, [...systemTemplates, ...customTemplates]);
}

// 获取所有可用模板（统一从 localStorage 读取）
export function getAllTemplates(): ContractTemplate[] {
  return loadFromLocalStorage<ContractTemplate[]>(STORAGE_KEYS.TEMPLATES) || [];
}

// 根据 ID 获取模板
export function getTemplateById(id: string): ContractTemplate | undefined {
  return getAllTemplates().find(t => t.id === id);
}

// 保存整个模板列表到 localStorage
export function saveAllTemplates(templates: ContractTemplate[]): void {
  saveToLocalStorage(STORAGE_KEYS.TEMPLATES, templates);
}

// 本地存储工具函数
export function saveToLocalStorage<T>(key: string, data: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('保存到本地存储失败:', error);
    throw new Error('存储空间已满或无法访问本地存储');
  }
}

export function loadFromLocalStorage<T>(key: string): T | null {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('从本地存储读取失败:', error);
    return null;
  }
}

export function removeFromLocalStorage(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('删除本地存储数据失败:', error);
  }
}

export function clearAllData(): void {
  try {
    Object.values(STORAGE_KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.error('清除所有数据失败:', error);
  }
}

// 获取当前用户唯一ID（持久化存储在 localStorage）
const USER_ID_KEY = 'contract_current_user_id';
export function getUserId(): string {
  let uid = localStorage.getItem(USER_ID_KEY);
  if (!uid) {
    uid = 'user_' + Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
    localStorage.setItem(USER_ID_KEY, uid);
  }
  return uid;
}

export function setUserId(uid: string): void {
  localStorage.setItem(USER_ID_KEY, uid);
}

export function clearUserId(): void {
  localStorage.removeItem(USER_ID_KEY);
}

// 生成唯一ID
export function generateId(): string {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
}

// 格式化日期为 YYYY-MM-DD
export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 生成合同编号
export function generateContractNumber(): string {
  const now = new Date();
  const dateStr = formatDate(now).replace(/-/g, '');
  const random = Math.floor(1000 + Math.random() * 9000);
  return `HT-${dateStr}-${random}`;
}

// 获取/保存员工身份信息
export function getEmployeeInfo(): { name: string; company: string; phone: string } | null {
  return loadFromLocalStorage<{ name: string; company: string; phone: string }>(STORAGE_KEYS.EMPLOYEE_INFO);
}
export function saveEmployeeInfo(info: { name: string; company: string; phone: string }): void {
  saveToLocalStorage(STORAGE_KEYS.EMPLOYEE_INFO, { ...info, updatedAt: new Date().toISOString() });
}
export function hasEmployeeInfo(): boolean {
  return !!localStorage.getItem(STORAGE_KEYS.EMPLOYEE_INFO);
}

// 合同生成记录
export function saveContractRecord(record: ContractRecord): void {
  const records: ContractRecord[] = loadFromLocalStorage<ContractRecord[]>(STORAGE_KEYS.CONTRACT_RECORDS) || [];
  // 确保有审核状态，默认待审核
  if (!record.status) {
    record.status = '待审核';
  }
  records.unshift(record);
  saveToLocalStorage(STORAGE_KEYS.CONTRACT_RECORDS, records);
}

// 更新合同记录（用于审核操作）
export function updateContractRecord(id: string, updates: Partial<ContractRecord>): void {
  const records: ContractRecord[] = loadFromLocalStorage<ContractRecord[]>(STORAGE_KEYS.CONTRACT_RECORDS) || [];
  const idx = records.findIndex(r => r.id === id);
  if (idx !== -1) {
    records[idx] = { ...records[idx], ...updates };
    saveToLocalStorage(STORAGE_KEYS.CONTRACT_RECORDS, records);
  }
}

export function getContractRecords(): ContractRecord[] {
  return loadFromLocalStorage<ContractRecord[]>(STORAGE_KEYS.CONTRACT_RECORDS) || [];
}
export function readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(new Error('文件读取失败'));
    reader.readAsArrayBuffer(file);
  });
}

// 读取文件为文本
export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('文件读取失败'));
    reader.readAsText(file);
  });
}
